var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGroup237992 = function SvgGroup237992(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82812 13.875C2.61903 13.875 2.60938 13.8691 2.60938 10.6562",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75586 3.68229C4.75586 1.00805 4.76122 1 7.43815 1",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1198 3.41406C10.1198 1.00697 10.1144 1 7.4375 1",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2656 10.6562C12.2656 13.8653 12.2597 13.875 9.04688 13.875",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82812 13.875H9.04687",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2656 3.68262L12.2667 11.193",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60938 3.68262V11.193",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 3.68262H1",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29102 6.36426V11.1924",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 6.36426V11.1924",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58398 6.36426V11.1924",
    stroke: "#33587D",
    strokeWidth: 1.07292,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroup237992, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Group 237992.45dbf925.svg";
export { ForwardRef as ReactComponent };